
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warrantyfor.house",
      function () {
        return require("private-next-pages/warrantyfor.house/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warrantyfor.house"])
      });
    }
  